import type { ConnectorPath } from "./workflowDiagramTypes";

interface Props {
  connectorPaths: ConnectorPath[];
  color: string;
  horizontalGap: number;
}

const WorkflowEdges = ({ connectorPaths, color, horizontalGap }: Props) => {
  return (
    <svg
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "visible",
        pointerEvents: "none",
        strokeWidth: 2,
      }}
    >
      {connectorPaths.map((p, i) => (
        <path
          // eslint-disable-next-line @eslint-react/no-array-index-key
          key={i}
          d={`
        M ${p.x1},${p.y1}
        H ${p.x1 + horizontalGap}
        V ${p.y2}
        H ${p.x2}
        L ${p.x2 - 8},${p.y2 - 8}
        M ${p.x2},${p.y2}
        L ${p.x2 - 8},${p.y2 + 8}
        Z
      `}
          stroke={color}
          fill="none"
        />
      ))}
    </svg>
  );
};

export default WorkflowEdges;
